interface Props {
    className?: string;
}

export function BadAccidentsIcon({ className }: Props) {
    return (
        <svg className={className} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M55.73 77.2H38.8c-7 0-12.69-5.69-12.69-12.69V30.04c0-1.4 1.14-2.55 2.55-2.55h10.55c.65 0 1.17.53 1.17 1.17s-.53 1.17-1.17 1.17H28.66c-.11 0-.2.09-.2.2v34.46c0 5.7 4.64 10.35 10.34 10.35h16.93c5.7 0 10.35-4.64 10.35-10.35S61.43 54.15 55.73 54.15h-6.55c-.65 0-1.17-.53-1.17-1.17V30.04c0-.11-.09-.2-.2-.2h-2.52c-.65 0-1.17-.53-1.17-1.17s.53-1.17 1.17-1.17h2.52c1.4 0 2.55 1.14 2.55 2.55v21.77h5.37c7 0 12.69 5.69 12.69 12.69S62.73 77.2 55.73 77.2Z"
                fill="currentColor"
            />
            <path
                d="M49.18 42h-21.9c-.65 0-1.17-.53-1.17-1.17s.53-1.17 1.17-1.17h21.9c.65 0 1.17.53 1.17 1.17S49.83 42 49.18 42Z"
                fill="currentColor"
            />
            <path
                d="M30.14 73.27c-.3 0-.6-.11-.83-.34-.46-.46-.46-1.2 0-1.66l19.04-19.04c.46-.46 1.2-.46 1.66 0 .46.46.46 1.2 0 1.66L30.97 72.93c-.23.23-.53.34-.83.34Z"
                fill="currentColor"
            />
            <path
                d="M58.91 76.75h-.02c-.65 0-1.17-.54-1.16-1.19l.28-22.06c0-.65.53-1.18 1.19-1.16.65 0 1.17.54 1.16 1.19l-.28 22.06c0 .64-.53 1.16-1.17 1.16Z"
                fill="currentColor"
            />
        </svg>
    );
}
